'use strict';

import {ITranslationRequest} from '../../modules/translation/translate.service';
import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UsanaObject} from '../../modules/usana-object';
import {LoggerService} from '../../modules/common/logger.service';
import {UserService} from '../../modules/common/user.service';
import {IShopUser} from '../../modules/session/customer-models';
import {DotcomTranslateService} from './dotcom-translate.service';

/**
 * Dotcom translate component (FR-022).
 *
 * All translations migrated from dotcom MUST use this component.
 * Mirrors TranslateComponent but always resolves keys via /translate?i18nPackage=usanadotcom
 * using the user's teasLocale.
 *
 * Usage: <span [dotcomTranslate]="'some.dotcom.key'"></span>
 */
@Component({
    selector: '[dotcomTag]',
    template: ``,
    standalone: true
})
export class DotcomTranslateComponent extends UsanaObject implements OnInit, OnChanges {

    @Input() dotcomTag: string;
    @Input() interpolate: any;
    @Input() key: string;
    @Input() translationRequest: ITranslationRequest;

    private teasLocale: string;

    constructor(
        private el: ElementRef,
        private dotcomTranslateService: DotcomTranslateService,
        private userService: UserService,
        loggerService: LoggerService
    ) {
        super(loggerService);
    }

    ngOnInit() {
        this.userService.getShopUserPromise().then((user: IShopUser) => {
            this.teasLocale = user?.teasLocale;
            if (this.dotcomTag && this.teasLocale) {
                this.dotcomTranslateService.translate(this.dotcomTag, this.teasLocale)
                    .then((val: string) => this.el.nativeElement.innerHTML = val);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.teasLocale) {
            return;
        }
        if (changes.translationRequest) {
            this.dotcomTranslateService.translateRequest(changes.translationRequest.currentValue, this.teasLocale)
                .then((val: string) => this.el.nativeElement.innerHTML = val);
        } else if (!!changes.interpolate && !!changes.key) {
            this.dotcomTranslateService.translateRequest({
                tag: this.dotcomTag,
                replacements: new Map([[this.key.toString(), this.interpolate.toString()]])
            }, this.teasLocale).then((val: string) => this.el.nativeElement.innerHTML = val);
        } else if (!!changes.interpolate && typeof changes.interpolate === 'object' && !!changes.interpolate.currentValue) {
            this.dotcomTranslateService.translateRequest({
                tag: this.dotcomTag,
                replacements: new Map(Object.entries(changes.interpolate.currentValue))
            }, this.teasLocale).then((val: string) => this.el.nativeElement.innerHTML = val);
        } else if (changes.dotcomTranslate?.currentValue !== changes.dotcomTranslate?.previousValue) {
            this.dotcomTranslateService.translate(this.dotcomTag, this.teasLocale)
                .then((val: string) => this.el.nativeElement.innerHTML = val);
        }
    }
}
